import { ModalHeader } from "@nextui-org/react";
import allariaMasLogo from "../../../../assets/images/logos/allaria+-logo-white.svg";
import { colors } from "../../../../styles/_variables.ts";
import useScreenSize from "../../../../hooks/useScreenSize.tsx";

const AllariaMasHeader = () => {
  const { isMobile } = useScreenSize();

  if (isMobile) {
    return (
      <div
        className="flex justify-center items-center p-4"
        style={{ backgroundColor: colors.allariaMasPrimary.normal[400] }}
      >
        <img src={allariaMasLogo} alt="Allaria+" />
      </div>
    );
  }

  return (
    <ModalHeader
      className="p-6 flex items-center justify-center"
      style={{ backgroundColor: colors.allariaMasPrimary.normal[400] }}
    >
      <img src={allariaMasLogo} alt="Allaria+" />
    </ModalHeader>
  );
};

export default AllariaMasHeader;
